import { render, staticRenderFns } from "./mapa.vue?vue&type=template&id=180ad1d4&"
import script from "./mapa.vue?vue&type=script&lang=js&"
export * from "./mapa.vue?vue&type=script&lang=js&"
import style0 from "./mapa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports